import { NgModule } from '@angular/core';

import { InputTagComponent } from '@app/shared/modules/input-tag/components/input-tag.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule } from '@angular/forms';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ScrollableContainerDirective } from '@app/shared/directives/scrollable-container.directive';

@NgModule({
  imports: [NzInputModule, FormsModule, NzTagModule, NgForOf, NgIf, ScrollableContainerDirective, NgClass],
  exports: [InputTagComponent],
  declarations: [InputTagComponent],
})
export class InputTagModule {}
